import { themeConfig } from '@themeConfig'
const theme = {
  defaultTheme: localStorage.getItem(`${themeConfig.app.title}-theme`) || themeConfig.app.theme.value,
  themes: {
    light: {
      dark: false,
      colors: {
        'primary': localStorage.getItem(`${themeConfig.app.title}-lightThemePrimaryColor`) || '#45B5A9',
        'primary-dark': '#3F998F',
        'primary-darker': '#0FA091',
        'primary-light': '#e9f4f3',
        'surface-alt': '#f8f8f9',
        'secondary': '#8A8D93',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#F4F5FA',
        'on-background': '#3A3541',
        'on-surface': '#3A3541',
        'grey-50': '#FAFAFA',
        'grey-100': '#F5F5F5',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
      },
      variables: {
        'border-color': '#3A3541',
        'medium-emphasis-opacity': 0.68,

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    dark: {
      dark: true,
      colors: {
        'primary': localStorage.getItem(`${themeConfig.app.title}-darkThemePrimaryColor`) || '#5CC8BD',
        'primary-dark': '#4DB6AC',
        'primary-darker': '#3F998F',
        'primary-light': '#1a3331',
        'surface-alt': '#1e2a29',
        'secondary': '#8A8D93',
        'on-secondary': '#fff',
        'success': '#6AD63A',
        'info': '#40C4FF',
        'warning': '#FFC940',
        'error': '#FF6B6F',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#1a1a1a',
        'background': '#121A19',
        'surface': '#1A2524',
        'on-background': '#E2E8E7',
        'on-surface': '#E2E8E7',
        'grey-50': '#1A2524',
        'grey-100': '#1E2C2B',
        'grey-200': '#2A3D3B',
        'grey-300': '#3A524F',
        'grey-400': '#5A7A76',
        'grey-500': '#7A9A96',
        'grey-600': '#9AB4B1',
        'grey-700': '#B2C8C6',
        'grey-800': '#CCD8D7',
        'grey-900': '#E2E8E7',
      },
      variables: {
        'border-color': '#E2E8E7',
        'medium-emphasis-opacity': 0.68,

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(0, 10, 8, 0.2)',
        'shadow-key-penumbra-opacity': 'rgba(0, 10, 8, 0.14)',
        'shadow-key-ambient-opacity': 'rgba(0, 10, 8, 0.12)',
      },
    },
  },
}
export default theme
